<template>
  <div>
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>医疗分类平均费用 (最近一年)</span>
        <el-button style="float: right; padding: 3px 0" type="text">...</el-button>
      </div>
      <div class="text item" style="min-height: 590px;">
        <div id="fengyong" style="height: 500px; margin:0 auto"></div>
      </div>
    </el-card>
  </div>
</template>

<script>
import echarts from "echarts";
// import MiduChart from './widgets/miduCharts'
export default {
  name: "suifang-charts",
  components: {
    // miduchart: MiduChart
  },
  mounted() {
    let that = this;
    that.drawPie();
  },
  methods: {
    drawPie() {
      // 基于准备好的dom，初始化echarts实例
      let myChart = echarts.init(document.getElementById("fengyong"));
      // 绘制图表
      myChart.setOption({
        title: {
          text: "费用数据分布",
          subtext: "测试数据",
          x: "center"
        },
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b} : {c} ({d}%)"
        },
        legend: {
          orient: "vertical",
          left: "left"
        },
        series: [
          {
            name: "费用数据",
            type: "pie",
            radius: "55%",
            center: ["50%", "60%"],
            data: [
              { value: 122.97, name: "床位费" },
              { value: 22.53, name: "护理费" },
              { value: 2454.46, name: "西药费" },
              { value: 10.14, name: "中成药" },
              { value: 0.93, name: "中草药" },
              { value: 77.05, name: "放射费" },
              { value: 1218.25, name: "化验费" },
              { value: 1.87, name: "输氧费" },
              { value: 65.97, name: "输血费" },
              { value: 505.64, name: "治疗费" },
              { value: 255.64, name: "手术费" },
              { value: 1255.64, name: "检查费" },
              { value: 403.12, name: "麻醉费" },
              { value: 423.32, name: "其他" }
            ],
            itemStyle: {
              emphasis: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)"
              }
            }
          }
        ]
      });
    }
  }
};
</script>

<style scoped>
table {
}
th,
td {
  text-align: left;
  border: 1px solid #ccc;
  padding: 7px 10px;
}
</style>
